import { isDevMode } from '@angular/core';

/**
 * Logs a debug message to the console only in development mode.
 * In production builds, all calls are no-ops — no sensitive data leaks to browser console.
 *
 * @param context A bracketed context label, e.g. 'AdminDashboard'.
 * @param message The human-readable message.
 * @param data Optional structured data object to log alongside the message.
 */
export function debugLog(context: string, message: string, data?: unknown): void {
  if (isDevMode()) {
    if (data) {
      console.log(`[${context}]`, message, data);
    } else {
      console.log(`[${context}]`, message);
    }
  }
}

/**
 * Logs a warning to the console only in development mode.
 */
export function debugWarn(context: string, message: string, data?: unknown): void {
  if (isDevMode()) {
    if (data) {
      console.warn(`[${context}]`, message, data);
    } else {
      console.warn(`[${context}]`, message);
    }
  }
}
